import {Panel, PanelCol, PanelContainer, Triangle} from './Panel';

import Picture from '../assets/images/picture-02.svg';
import PictureTriangle from '../assets/images/triangle.svg';
import {t} from 'i18next';

type ErrorPanelProps = {
  errorMessage: string;
};

const ErrorPanel = ({errorMessage}: ErrorPanelProps) => {
  return (
    <PanelContainer>
      <Panel>
        <PanelCol>
          <Triangle src={PictureTriangle} alt="" />
          <img src={Picture} alt="" />
        </PanelCol>
        <PanelCol>
          <h1>{t(errorMessage ? errorMessage : '')}</h1>
        </PanelCol>
      </Panel>
    </PanelContainer>
  );
};

export default ErrorPanel;
